import React, { useEffect, useRef, useState } from "react";

import sanitizeHtml from 'sanitize-html';
import { useLocation,useNavigate} from "react-router-dom";
import { useSelector } from 'react-redux';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import GameSvcMnyDpstPrdtCtntApi from "Apis/GameSvcMnyDpstPrdtCtntApi";
import GameSvcMnyDpstPrdtAllLstApi from "Apis/GameSvcMnyDpstPrdtAllLstApi";
import PymtMthdLstApi from "Apis/PymtMthdLstApi";
import PymtMthdEvntApi from "Apis/PymtMthdEvntApi";
import EtcCtxtApi from "Apis/EtcCtxtApi";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import DpstOdrInfotApi from "Apis/DpstOdrInfotApi";
import MembGameSvcMnyApi from "Apis/MembGameSvcMnyApi";
import "Assets/css/Shop.css";
import "Assets/css/GameMnyDpst.css";
import ImgWithFallback from "Utils/ImgWithFallback";
import { DpstOdrCrdtFunc } from "Utils/DpstOdrCrdtFunc";
import ApiResultModal from "Components/ApiResultModal";

declare global {
    interface Window { kmcRespFunc: any; }
}

interface prdtCtntReps {
    gameSvcCd:string,
    prdtKindCd:string,
    prdtNm:string,
    prdtDesc:string,
    prdtUntPrc:string,
    pchsCrncyCd:string,
    pchsCrncySign:string,
    paidMny:string,
    freeMny:string,
    gameMnyNm:string,
    imgUrl:string,
    pchsLmtCnt:number,
    trxAllwYn:string,
    subsIntvNm:null,
    aplyStrtDtime:string,
    aplyStopDtime:string,
    allTimeYn:string,
    lmtYn?: string,
    soutYn?: string
}

interface ShopCtntMdlalUiProps {
    gameSvcCd?: string;
    shopKindCd?: string;
    prdtCd?: string;
    rcmnPrdtCd?: string;
    pymtCrncyType?: string;
    forceCtntModal?: boolean;
    onRequestClose?: (getPrdtCd: string, pymtMthdCd: string, prdtPrc: string, prdtCnt: number, odrAmt: string) => void;
    onRequestSwitchToItemModal?: (prdtCd: string, sourcePrdtCd: string) => void;
    onBeforeSubmit?: () => void;
    useParentDpstResultHandler?: boolean;
    prdtLstState?: any[]|null;
}

const ShopCtntMdlalUi =({ gameSvcCd: propGameSvcCd, shopKindCd: propShopKindCd, prdtCd: propPrdtCd, rcmnPrdtCd: propRcmnPrdtCd, pymtCrncyType: propPymtCrncyType, forceCtntModal = false, onRequestClose, onRequestSwitchToItemModal, onBeforeSubmit, useParentDpstResultHandler = false, prdtLstState: _prdtLstState }: ShopCtntMdlalUiProps) => {
    const navigate = useNavigate();
    const location= useLocation();
    
    // 전역 store에서 로그인 정보 실시간 구독
    const loginInfoRaw = useSelector((state: any) => state.LoginInfoState?.LoginInfo);
    const loginInfo = loginInfoRaw?.apiBody;
    const storeLang = useSelector((state: any) => state.LangSetState?.Lang);
    
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = propGameSvcCd || query.get("gameSvcCd");
    const [selectedPrdtCdState, setSelectedPrdtCdState] = useState<string>(propPrdtCd || query.get("prdtCd") || "");
    const getPrdtCd = selectedPrdtCdState;
    const {isLoading,error,data: langData}:any = UseLangLstQuery();

    const [ShopKindCdState,setshopKindCdState] = useState<string | null>(propShopKindCd || query.get("shopKindCd"));

    const [imgUrlState,setImgUrlState] = useState<string | undefined>(undefined);
    const [prdtNmState,setPrdtNmState] = useState<string | undefined>(undefined);
    const [prdtDescState,setPrdtDescState] = useState<string | undefined>(undefined);
    const [pchsLmtCntState,setPchsLmtCntState] = useState<number>(0);
    const [prdtUntPrcState,setPrdtUntPrcState] = useState<number>(0);
    const [paidMnyState,setPaidMnyState] = useState<number>(0);
    const [freeMnyState,setFreeMnyState] = useState<number>(0);
    const [totMnyState,setTotMnyState] = useState<string>("0");
    const [pchsCrncySignState,setPchsCrncySignState] = useState<string | undefined>(undefined);
    const [allTimeYnState,setAllTimeYnState] = useState<string | undefined>(undefined);
    const [lmtYnState, setLmtYnState] = useState<string>("N");
    const [soutYnState, setSOutYnState] = useState<string>("N");
    const [aplyStrtDtimeState,setAplyStrtDtime] = useState<string | undefined>(undefined);
    const [aplyStopDtimeState,setAplyStopDtime] = useState<string | undefined>(undefined);
    const [prdtCtntRepsState,setPrdtCtntRepsState] = useState<prdtCtntReps | null>(null);
    const [countState,setCountState] = useState(1);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const [modalStepState, setModalStepState] = useState<1 | 2>(1);
    const [oneLmtCntState, setOneLmtCntState] = useState<number>(0);
    const [pymtMthdCdState,setPymtMthdCdState] = useState("");
    const [pgCdState,setPgCdState] = useState("");
    const [pymtMthdLstState,setPymtMthdLstState] = useState<any[]>([]);
    const [showAllPymtMthdState, setShowAllPymtMthdState] = useState(false);
    const [agreChkState,setAgreChkState] = useState<string[]>([]);
    const [pymtMthdEvntState,setPymtMthdEvntState] = useState<any>(null);
    const [pymtGuideCtxtState, setPymtGuideCtxtState] = useState("");
    const [dpstResultOpenState, setDpstResultOpenState] = useState(false);
    const [dpstResultLoadingState, setDpstResultLoadingState] = useState(false);
    const [dpstResultDataState, setDpstResultDataState] = useState<any>(null);
    const [dpstOdrInfoState, setDpstOdrInfoState] = useState<any>(null);
    const [fallbackPrdtLstState, setFallbackPrdtLstState] = useState<any[]>([]);
    const [rcmnPrdtCdState, setRcmnPrdtCdState] = useState<string>("");
    const handledDpstResultRef = useRef<{ key: string; receivedAt: number }>({ key: "", receivedAt: 0 });
    const isPageReady = Boolean(langData && prdtCtntRepsState && !isLoading);
    const isLoginInfoResolved = loginInfoRaw !== null;
    const totalPrice = Number(prdtUntPrcState || 0) * countState;

    const payTypeEnabledMethods = [
        "CREDITCARD",
        "MOBILEPYMT",
        "RLTMACCT",
        "GIFTBOOK",
        "GIFTCLTR",
        "GIFTHPPY",
        "GIFTSMRT",
        "BKAKAOPAY",
        "BNAVERPAY",
        "BTOSSPAY"
    ];
    const shouldRenderPayType = payTypeEnabledMethods.includes(pymtMthdCdState);
    const hasMorePymtMthd = pymtMthdLstState.length > 4;
    const collapsedPymtMthdLst = pymtMthdLstState.slice(0, 4);
    const visiblePymtMthdLst = showAllPymtMthdState ? pymtMthdLstState : collapsedPymtMthdLst;
    const sourcePrdtLst = fallbackPrdtLstState;
    const availablePrdtLst = (sourcePrdtLst || []).filter((item: any) => item.soutYn !== "Y");
    const mnyPrdtLst = availablePrdtLst.filter((item: any) => item.prdtKindCd === "MNY");
    const isMnyShopKind = String(ShopKindCdState || "").trim().toUpperCase() === "MNY";
    const hasPrdtSelectOptions = isMnyShopKind && mnyPrdtLst.length > 0;
    const prdtSelectRef = useRef<HTMLDivElement | null>(null);
    const [isPrdtSelectOpenState, setIsPrdtSelectOpenState] = useState(false);
    const [hoverPrdtCdState, setHoverPrdtCdState] = useState<string>("");

    const selectedPrdtItem = mnyPrdtLst.find((item: any) => String(item.prdtCd) === String(getPrdtCd));
    const hoveredPrdtItem = mnyPrdtLst.find((item: any) => String(item.prdtCd) === String(hoverPrdtCdState));
    const requestedPrdtCd = String(propPrdtCd || query.get("prdtCd") || "");

    useEffect(() => {
        setSelectedPrdtCdState(propPrdtCd || query.get("prdtCd") || "");
    }, [propPrdtCd, location.search]);

    useEffect(() => {
        setRcmnPrdtCdState(String(propRcmnPrdtCd || ""));
    }, [propRcmnPrdtCd]);

    useEffect(() => {
        if (!isMnyShopKind || !mnyPrdtLst.length) {
            return;
        }

        const hasRequested = Boolean(requestedPrdtCd);
        const hasRequestedInList = hasRequested && mnyPrdtLst.some((item: any) => String(item.prdtCd) === requestedPrdtCd);
        const isCurrentSelectable = mnyPrdtLst.some((item: any) => String(item.prdtCd) === String(getPrdtCd));

        if (hasRequestedInList) {
            // Keep requested prdt only when current selection is empty/invalid.
            // If user already selected a valid option, do not force-reset it.
            if (!isCurrentSelectable && String(getPrdtCd) !== requestedPrdtCd) {
                setSelectedPrdtCdState(requestedPrdtCd);
            }
            return;
        }

        if (!isCurrentSelectable && !hasRequested) {
            setSelectedPrdtCdState(String(mnyPrdtLst[0]?.prdtCd || ""));
        }
    }, [isMnyShopKind, mnyPrdtLst, getPrdtCd, requestedPrdtCd]);

    useEffect(() => {
        if (!isPrdtSelectOpenState) {
            return;
        }

        const onClickOutside = (event: MouseEvent) => {
            if (!prdtSelectRef.current) {
                return;
            }
            if (!prdtSelectRef.current.contains(event.target as Node)) {
                setIsPrdtSelectOpenState(false);
                setHoverPrdtCdState("");
            }
        };

        document.addEventListener("mousedown", onClickOutside);
        return () => {
            document.removeEventListener("mousedown", onClickOutside);
        };
    }, [isPrdtSelectOpenState]);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = (runAction: boolean = true) => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (runAction && action) action();
    };

    useEffect(() => {
        const handleDpstApiMessage = (event: Event) => {
            const customEvent = event as CustomEvent<{ code?: string; message?: string }>;
            const code = String(customEvent?.detail?.code || "");
            if (code !== "PYMT3526") {
                return;
            }

            setResultModalMessage(customEvent?.detail?.message || "결제 처리 중 오류가 발생했습니다.");
            setModalAction(null);
            setResultModalOpen(true);
        };

        window.addEventListener("dpst-api-message", handleDpstApiMessage as EventListener);
        return () => {
            window.removeEventListener("dpst-api-message", handleDpstApiMessage as EventListener);
        };
    }, []);

    const AgreTrmsFunc = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        if (checked) {
            setAgreChkState((prev) => (prev.includes(name) ? prev : [...prev, name]));
            return;
        }
        setAgreChkState((prev) => prev.filter((choice) => choice !== name));
    };

    const PymtMthdClickFunc = (pymtMthdCd: string, pgCd: string) => {
        setPymtMthdCdState(pymtMthdCd);
        setPgCdState(pgCd);
        if (!getGameSvcCd || !getPrdtCd) {
            return;
        }
        PymtMthdEvntApi(getGameSvcCd, pymtMthdCd, getPrdtCd)
            .then((resp) => {
                setPymtMthdEvntState(resp.apiBody);
            })
            .catch(() => {
                setPymtMthdEvntState(null);
            });
    };

    const PymtBtnOnClickFunc = () => {
        if (!isPageReady) {
            openResultModal(langData?.COMM_MAIN_LOADING_00 || "로딩중입니다. 잠시 후 다시 시도해주세요.");
            return;
        }
        if (!loginInfo || !loginInfo.login) {
            const currentUrl = encodeURIComponent(location.pathname + location.search);
            openResultModal(
                langData?.COMM_ALERT_LOGIN_REQUIRED_00 || "로그인이 필요한 서비스입니다.",
                () => navigate(`/Login?referrer=${currentUrl}`)
            );
            return;
        }
        if (!pymtMthdCdState) {
            openResultModal(langData?.GAME_MNY_DPST_MTHD_TITL_00 || "결제 수단을 선택해주세요.");
            return;
        }
        if (!agreChkState.includes("agrePrivacy")) {
            openResultModal(langData?.GAME_MNY_DPST_TRMS_LBL_00 || "게임재화 이용약관 동의가 필요합니다.");
            return;
        }
        if (!getGameSvcCd || !ShopKindCdState || !getPrdtCd) {
            openResultModal(langData?.GAME_SHOP_INVALID_PRDT_INFO_00 || "결제에 필요한 상품 정보가 올바르지 않습니다.");
            return;
        }

        try {
            window.sessionStorage.setItem(
                "shopDpstReturnContext",
                JSON.stringify({
                    gameSvcCd: String(getGameSvcCd || "BBO"),
                    shopKindCd: String(ShopKindCdState || "MNY"),
                    prdtCd: String(getPrdtCd || ""),
                    pymtMthdCd: String(pymtMthdCdState || ""),
                    prdtPrc: String(prdtUntPrcState || 0),
                    prdtCnt: Number(countState || 0),
                    odrAmt: String(totalPrice || 0),
                })
            );
        } catch {
            // ignore session storage write errors
        }

        onBeforeSubmit?.();
        DpstOdrCrdtFunc(
            getGameSvcCd,
            pymtMthdCdState,
            ShopKindCdState,
            getPrdtCd,
            countState,
            String(totalPrice),
            String(prdtUntPrcState || 0),
            pgCdState,
            rcmnPrdtCdState
        );
    };

    const CntStateChngFunc = (ArithmeticOperators:string) => {
        if (soutYnState === "Y") {
            return;
        }
        switch(ArithmeticOperators){
            case "+":
                if(pchsLmtCntState != 0) {
                    if(countState < pchsLmtCntState){
                        setCountState(countState+1);
                    }
                    else {
                        break;
                    }
                }else {
                    setCountState(countState+1);
                }
            break;
            case "-":
                if(countState <= 1){
                    break;
                }else {
                    setCountState(countState-1)
                }
            break;
        }
    }
    const GotoDpstLstFunc = () => {
        closeResultModal(false);
        if (onRequestClose) {
            onRequestClose(
                String(getPrdtCd || ""),
                pymtMthdCdState,
                String(prdtUntPrcState || 0),
                countState,
                String(totalPrice),
            );
        }
        // navigate(`/MyPage/GameSvcMnyDpstLst`);
    }

    const closeDpstResultUi = () => {
        setDpstResultOpenState(false);
        setDpstResultDataState(null);
        setDpstOdrInfoState(null);
        handledDpstResultRef.current = { key: "", receivedAt: 0 };
        GotoDpstLstFunc();
    };

    // 팝업에서 opener.GotoDpstLstFunc() 호출 가능하도록 window에 등록
    useEffect(() => {
        (window as any).GotoDpstLstFunc = GotoDpstLstFunc;
        return () => {
            delete (window as any).GotoDpstLstFunc;
        };
    }, [getPrdtCd, pymtMthdCdState, prdtUntPrcState, countState, totalPrice, onRequestClose]);

    useEffect(() => {
        setTotMnyState(String(loginInfo?.totMny ?? "0"));
    }, [loginInfo?.totMny]);

    useEffect(() => {
        if (!getGameSvcCd || !ShopKindCdState) {
            setFallbackPrdtLstState([]);
            return;
        }

        // 상품 선택 리스트는 부모 페이징 리스트를 사용하지 않고 항상 전체 목록 API로 조회한다.
        GameSvcMnyDpstPrdtAllLstApi(getGameSvcCd, "MNY")
            .then((resp: any) => {
                setFallbackPrdtLstState(resp?.apiBody?.prdtLst || []);
            })
            .catch(() => {
                setFallbackPrdtLstState([]);
            });
    }, [getGameSvcCd, ShopKindCdState, storeLang]);

    useEffect(()=>{
        if(!isLoginInfoResolved || !storeLang) {
            return;
        }
        if(ShopKindCdState && getPrdtCd){
            GameSvcMnyDpstPrdtCtntApi(getGameSvcCd,ShopKindCdState,getPrdtCd).then((resp)=> {
                switch(resp.apiHdr.code) {
                    case "PYMT0000":
                        setImgUrlState(resp.apiBody.imgUrl)
                        setPrdtNmState(resp.apiBody.prdtNm)
                        setPchsLmtCntState(Number(resp.apiBody.pchsLmtCnt) || 0)
                        setPrdtUntPrcState(Number(resp.apiBody.prdtUntPrc) || 0)
                        setPchsCrncySignState(resp.apiBody.pchsCrncySign)
                        setAllTimeYnState(resp.apiBody.allTimeYn);
                        setLmtYnState(resp.apiBody.lmtYn || "N");
                        setSOutYnState(resp.apiBody.soutYn || "N");
                        setAplyStrtDtime(resp.apiBody.aplyStrtDtime);
                        setAplyStopDtime(resp.apiBody.aplyStopDtime);
                        setPaidMnyState((Number(resp.apiBody.paidMny) || 0));
                        setFreeMnyState((Number(resp.apiBody.freeMny) || 0));
                        setOneLmtCntState(resp.apiBody.oneLmtCnt || 0);
                        setPrdtCtntRepsState(resp.apiBody as prdtCtntReps);
                        const dirty = resp.apiBody.prdtDesc || '';
                        const sanitized = sanitizeHtml(dirty,{});
                        setPrdtDescState(sanitized);
                    break;
                    default:
                        openResultModal(`${resp.apiHdr.msg}`,() => {
                            GotoDpstLstFunc();
                        });
                }
            }).catch(()=>{
                // ignore for now
            })
        }
    },[ShopKindCdState, getGameSvcCd, getPrdtCd, isLoginInfoResolved, storeLang])

    useEffect(() => {
        setCountState(1);
        setPymtMthdCdState("");
        setPgCdState("");
        setAgreChkState([]);
        setPymtMthdEvntState(null);
        setIsPrdtSelectOpenState(false);
        setHoverPrdtCdState("");
    }, [getPrdtCd]);

    useEffect(() => {
        setShowAllPymtMthdState(false);
    }, [getPrdtCd, ShopKindCdState]);

    useEffect(() => {
        if (!getGameSvcCd || !getPrdtCd) {
            return;
        }
        PymtMthdLstApi(getGameSvcCd, getPrdtCd)
            .then((resp) => {
                setPymtMthdLstState(resp.apiBody?.pymtMthdLst || []);
            })
            .catch(() => {
                setPymtMthdLstState([]);
            });
    }, [getGameSvcCd, getPrdtCd, storeLang]);

    useEffect(() => {
        const etcGameSvcCd = String(getGameSvcCd || "BBO").toUpperCase();
        EtcCtxtApi("CTNT_KIND_ETC", "PYMT_GUIDE", etcGameSvcCd)
            .then((resp) => {
                if (resp.apiHdr.code === "COMM0000") {
                    setPymtGuideCtxtState(resp.apiBody.ctxt);
                }
            })
            .catch(() => {
                setPymtGuideCtxtState("");
            });
    }, [getGameSvcCd, storeLang]);

    useEffect(() => {
        function kmcRespFunc(kmcApiTknrslt: string, kmcApiCertNumrslt: string) {
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt, kmcApiCertNumrslt)
                .then((resp) => {
                    if (resp.apiHdr.code === "ATHN0000") {
                        if (!getGameSvcCd || !ShopKindCdState || !getPrdtCd) {
                            openResultModal(langData?.GAME_SHOP_INVALID_PRDT_INFO_00 || "결제에 필요한 상품 정보가 올바르지 않습니다.");
                            return;
                        }
                        onBeforeSubmit?.();
                        DpstOdrCrdtFunc(
                            getGameSvcCd,
                            pymtMthdCdState,
                            ShopKindCdState,
                            getPrdtCd,
                            countState,
                            String(totalPrice),
                            String(prdtUntPrcState || 0),
                            pgCdState,
                            rcmnPrdtCdState
                        );
                        return;
                    }
                    openResultModal(`${resp.apiHdr.msg}`);
                })
                .catch((error: any) => {
                    openResultModal(error?.message || langData?.GAME_MNY_ATHN_VRF_FAIL_00 || "본인인증 검증 중 오류가 발생했습니다.");
                });
        }

        window.kmcRespFunc = kmcRespFunc;

        return () => {
            try { window.kmcRespFunc = undefined; } catch (e) {}
        };
    }, [getGameSvcCd, getPrdtCd, ShopKindCdState, pymtMthdCdState, countState, totalPrice, prdtUntPrcState, pgCdState]);

    useEffect(() => {
        if (useParentDpstResultHandler) {
            return;
        }

        const processDpstResult = async (rawData: any) => {
            const data: any = rawData;
            console.log("[ShopCtntMdlalUi] processDpstResult called", data);
            if (!data || typeof data !== "object") {
                console.log("[ShopCtntMdlalUi] ignored: payload is not object", data);
                return;
            }
            if (data.type !== "navigateToResult" && data.type !== "dpstResult") {
                console.log("[ShopCtntMdlalUi] ignored: unknown type", data.type);
                return;
            }

            const receivedDpstOdrNo = String(data.dpstOdrNo || "");
            const receivedDpstCode = String(data.dpstCode || "");
            const receivedDpstMsg = String(data.dpstMsg || "");
            const receivedRcmnPrdtCd = String(data.rcmnPrdtCd || "");
            const normalizedRcmnPrdtCd = receivedRcmnPrdtCd.trim();
            const receivedPymtMthdNm = String(data.pymtMthdNm || "");

            console.log("[ShopCtntMdlalUi] parsed callback payload", {
                dpstCode: receivedDpstCode,
                dpstMsg: receivedDpstMsg,
                rcmnPrdtCd: receivedRcmnPrdtCd,
                normalizedRcmnPrdtCd,
                pymtMthdNm: receivedPymtMthdNm,
            });

            if (normalizedRcmnPrdtCd && onRequestSwitchToItemModal) {
                console.log("[ShopCtntMdlalUi] switching to ShopItemMdalUi by rcmnPrdtCd", normalizedRcmnPrdtCd);
                setRcmnPrdtCdState(String(getPrdtCd || ""));
                onRequestSwitchToItemModal(normalizedRcmnPrdtCd, String(getPrdtCd || ""));
                return;
            }

            const resultKey = receivedDpstOdrNo || `${receivedDpstCode}|${receivedDpstMsg}|${receivedRcmnPrdtCd}|${receivedPymtMthdNm}`;
            const now = Date.now();

            if (!resultKey) {
                console.log("[ShopCtntMdlalUi] ignored: empty result key", data);
                return;
            }
            if (
                handledDpstResultRef.current.key === resultKey &&
                now - handledDpstResultRef.current.receivedAt < 3000
            ) {
                console.log("[ShopCtntMdlalUi] ignored: duplicate result", resultKey);
                return;
            }
            handledDpstResultRef.current = {
                key: resultKey,
                receivedAt: now,
            };

            const targetGameSvcCd = String(data.gameSvcCd || getGameSvcCd || "BBO");
            const normalizedPchsKindCd = String(
                data.pchsKindCd || data.prdtKindCd || ShopKindCdState || "DPST"
            ).trim().toUpperCase();

            setDpstResultOpenState(true);
            setDpstResultLoadingState(true);
            setDpstResultDataState({
                dpstOdrNo: receivedDpstOdrNo,
                dpstCode: receivedDpstCode,
                dpstMsg: receivedDpstMsg,
                gameSvcCd: targetGameSvcCd,
                rcmnPrdtCd: receivedRcmnPrdtCd,
                pymtMthdNm: receivedPymtMthdNm,
                pchsKindCd: normalizedPchsKindCd,
            });
            console.log("[ShopCtntMdlalUi] accepted deposit result", {
                dpstOdrNo: receivedDpstOdrNo,
                dpstCode: receivedDpstCode,
                gameSvcCd: targetGameSvcCd,
            });
            setDpstOdrInfoState(null);

            try {
                if ((receivedDpstCode === "PYMT0000" || receivedDpstCode === "PYMT3502") && receivedDpstOdrNo) {
                    const [orderInfoResult, mnyResult] = await Promise.allSettled([
                        DpstOdrInfotApi(targetGameSvcCd, receivedDpstOdrNo, String(storeLang || "ko")),
                        MembGameSvcMnyApi(targetGameSvcCd),
                    ]);

                    if (orderInfoResult.status === "fulfilled") {
                        setDpstOdrInfoState(orderInfoResult.value?.apiBody || null);
                    }

                    if (mnyResult.status === "fulfilled") {
                        setTotMnyState(String(mnyResult.value?.apiBody?.totMny ?? "0"));
                    }
                }
            } finally {
                setDpstResultLoadingState(false);
                console.log("[ShopCtntMdlalUi] deposit result handling finished", {
                    dpstOdrNo: receivedDpstOdrNo,
                    dpstCode: receivedDpstCode,
                });
            }
        };

        const handleMessage = async (event: MessageEvent) => {
            console.log("[ShopCtntMdlalUi] message event received", {
                origin: event.origin,
                data: event.data,
            });
            if (event?.data === "closePop") {
                console.log("[ShopCtntMdlalUi] received closePop (no rcmnPrdtCd from callback)");
                return;
            }
            await processDpstResult(event?.data);
        };

        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [getGameSvcCd, storeLang, onRequestSwitchToItemModal, useParentDpstResultHandler]);


    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
            confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        {dpstResultOpenState ? (
            <div className="shopCtntStepWrap">
                <div className="shopContainer shopCtntStepBody">
                    <div className="dpstResultWrap">
                        {dpstResultLoadingState ? (
                            <div className="loadingWrap">
                                <p>{langData?.GAME_DPST_RSLT_LOAD_MSG_00 || "충전 결과를 확인하고 있습니다..."}</p>
                            </div>
                        ) : (
                            <>
                                <div className="dpstResultHeader">
                                    <div className={dpstResultDataState?.dpstCode === "PYMT0000" ? "successIcon" : "failureIcon"}>
                                        {dpstResultDataState?.dpstCode === "PYMT0000" ? "✓" : "✗"}
                                    </div>
                                    <h1>
                                        {dpstResultDataState?.dpstCode === "PYMT0000"
                                            ? (langData?.GAME_DPST_RSLT_SUCC_MSG_00 || "충전이 완료되었습니다!")
                                            : (langData?.GAME_DPST_RSLT_FAIL_MSG_00 || "충전에 실패했습니다.")}
                                    </h1>
                                </div>

                                <div className="dpstResultInfo">
                                    <div className="dpstResultItem">
                                        <span className="label">{langData?.GAME_DPST_RSLT_ORDER_NO_00 || "주문번호"}</span>
                                        <span className="value">{dpstResultDataState?.dpstOdrNo || "-"}</span>
                                    </div>
                                    {dpstResultDataState?.dpstCode === "PYMT0000" && (
                                        <>
                                            <div className="dpstResultItem">
                                                <span className="label">{langData?.GAME_DPST_RSLT_PRDT_NM_00 || "상품 명"}</span>
                                                <span className="value">{dpstOdrInfoState?.dpstPrdtNm || "-"}</span>
                                            </div>
                                            <div className="dpstResultItem">
                                                <span className="label">{langData?.GAME_DPST_RSLT_AFTER_DPST_00 || "충전 후 금액"}</span>
                                                <span className="value">{dpstOdrInfoState?.totMny ?? "-"}{dpstOdrInfoState?.gameMnyNm || ""}</span>
                                            </div>
                                            <div className="dpstResultItem">
                                                <span className="label">{langData?.GAME_DPST_RSLT_CURR_MNY_00 || "현재 보유 재화"}</span>
                                                <span className="value highlight">{Number(totMnyState || "0").toLocaleString()}{dpstOdrInfoState?.gameMnyNm || ""}</span>
                                            </div>
                                        </>
                                    )}
                                    {dpstResultDataState?.dpstCode !== "PYMT0000" && dpstResultDataState?.dpstMsg && (
                                        <div className="dpstResultItem">
                                            <span className="label">{langData?.GAME_DPST_RSLT_FAIL_REASON_00 || "실패 사유"}</span>
                                            <span className="value error">{dpstResultDataState.dpstMsg}</span>
                                        </div>
                                    )}
                                </div>

                                <div className={`dpstResultNotice ${dpstResultDataState?.dpstCode === "PYMT0000" ? "" : "failure"}`.trim()}>
                                    <h3>{langData?.GAME_DPST_RSLT_GUID_00 || "안내사항"}</h3>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: pymtGuideCtxtState || (langData && langData.GAME_MNY_DPST_DESC_00) || "결제 진행 시 유의사항을 꼭 확인하시기 바랍니다.",
                                        }}
                                    />
                                </div>

                                <div className="dpstResultBtnWrap">
                                    <button className="dpstResultBtn secondary" onClick={closeDpstResultUi}>
                                        <span>{langData?.GAME_DPST_RSLT_CLOSE_BTN_00 || "닫기"}</span>
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        ) : (
        <div className="shopCtntStepWrap" style={{padding:0}}>

            {modalStepState === 1 ? (
                <div className="shopContainer shopCtntStepBody">
                    <h1 className="trmsCtgrTitl ctntCtgrTitlTxt">{prdtNmState || (langData && langData.GAME_SHOP_PRDT_DESC_LBL_00)}</h1>
                    {prdtDescState != null ? (
                        <div
                            className="prdtDesc h500"
                            style={{ padding: "15px 0", whiteSpace: "pre-wrap" }}
                            dangerouslySetInnerHTML={{ __html: prdtDescState }}
                        />
                    ) : (
                        <div className="prdtDesc" style={{ padding: "15px 0" }}>
                            {langData?.COMM_MAIN_LOADING_00 || "로딩중입니다. 잠시 후 다시 시도해주세요."}
                        </div>
                    )}
                    <div className="shopCtntStepAction">
                        <p style={{fontSize:"20px",fontWeight:"700"}}><span>{pchsCrncySignState}</span>{(Number(prdtUntPrcState||0)).toLocaleString()}</p>
                        <button
                            type="button"
                            className="buttonBgB"
                            disabled={!isPageReady}
                            onClick={() => setModalStepState(2)}
                        >
                            <p>{langData?.COMM_MAIN_NEXT_BTN_00 || "다음"}</p>
                        </button>
                    </div>
                </div>
            ) : (
                <div className="shopContainer dFlex shopItemInfoContainer shopCtntStepBody">
                    <div className="itemImgWrap">
                        <div className="shopPrdtSelectWrap">
                            {hasPrdtSelectOptions ? (
                                <div className="shopPrdtSelectBox" ref={prdtSelectRef}>
                                    <button
                                        type="button"
                                        className={`shopPrdtSelectBtn ${isPrdtSelectOpenState ? "open" : ""}`}
                                        onClick={() => setIsPrdtSelectOpenState((prev) => !prev)}
                                    >
                                        <span>
                                            {selectedPrdtItem?.prdtNm || prdtNmState}
                                        </span>
                                    </button>
                                    {isPrdtSelectOpenState && (
                                        <div className="shopPrdtSelectLayer">
                                            <ul
                                                className="shopPrdtSelectOptions"
                                                onMouseLeave={() => setHoverPrdtCdState("")}
                                            >
                                                {mnyPrdtLst.map((item: any) => {
                                                    const isActive = String(getPrdtCd) === String(item.prdtCd);
                                                    return (
                                                        <li key={String(item.prdtCd)}>
                                                            <button
                                                                type="button"
                                                                className={`shopPrdtOptionBtn ${isActive ? "active" : ""}`}
                                                                onMouseEnter={() => setHoverPrdtCdState(String(item.prdtCd))}
                                                                onFocus={() => setHoverPrdtCdState(String(item.prdtCd))}
                                                                onClick={() => {
                                                                    setSelectedPrdtCdState(String(item.prdtCd));
                                                                    setIsPrdtSelectOpenState(false);
                                                                    setHoverPrdtCdState("");
                                                                }}
                                                            >
                                                                <span>{item.prdtNm}</span>
                                                            </button>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                            {hoverPrdtCdState && hoveredPrdtItem?.imgUrl && (
                                                <div className="shopPrdtThumbPreview" aria-hidden>
                                                    <ImgWithFallback src={hoveredPrdtItem.imgUrl} alt="" />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <h1 className="prdtNm">{prdtNmState}</h1>
                            )}
                        </div>
                        <div className={`itemImgFrame ${soutYnState === "Y" ? "disabled" : ""}${hasPrdtSelectOptions ? " hasPrdtSelectOptions" : ""}`}>
                            <ImgWithFallback src={imgUrlState} alt="" />
                        </div>  

                        <div>
                            {prdtDescState != null ? (
                                <>
                                    <div className="prdtDescWrap">
                                        <h2>{langData && langData.GAME_SHOP_PRDT_DESC_LBL_00 || "상품 설명"}</h2>
                                    {pchsLmtCntState == 0 && lmtYnState != "N"?
                                        <div className="itemLmtCntWrap">
                                            <p>{langData&&langData.GAME_SHOP_PRDT_CNT_LBL_00}</p>
                                            <span>{pchsLmtCntState}</span>
                                        </div>:
                                        <></>
                                    }
                                    </div>
                                    <div className="prdtDesc" style={{padding: "15px", whiteSpace: "pre-wrap"}}
                                        dangerouslySetInnerHTML={{ __html: prdtDescState }}
                                    />
                                </>
                            ) : null}
                        </div>
                    </div>
                    <div className="itemTxtWrap">
                        <div className="shopInlinePymtWrap">
                            <div className="shopInlinePymtTitl">{langData && langData.GAME_MNY_DPST_MTHD_TITL_00 || "결제 수단"}</div>
                            <span className="shopInlinePymtSubTitl">
                                {langData?.GAME_MNY_DPST_MTHD_DESC_00 || "지불 방식"}
                            </span>
                            <div className={`shopInlinePymtGrid ${showAllPymtMthdState && hasMorePymtMthd ? "expanded" : ""}`}>
                                {visiblePymtMthdLst && visiblePymtMthdLst.map((key:any) => (
                                    <div key={`${key.pymtMthdCd}-${key.pgCd}`} className="shopInlinePymtItem">
                                        <button
                                            type="button"
                                            className={`${key.dpstMntnYn == "Y" ? "disable " : (pymtMthdCdState==`${key.pymtMthdCd}` ? "active " : "")}${key.pymtMthdCd}`}
                                            disabled={key.dpstMntnYn == "Y"}
                                            onClick={() => {
                                                if (key.dpstMntnYn != "Y") {
                                                    PymtMthdClickFunc(`${key.pymtMthdCd}`,`${key.pgCd}`)
                                                }
                                            }}
                                        >
                                            {key.dpstMntnYn == "Y" ? (
                                                key.payImgUrl ? (
                                                    <img src={key.payImgUrl} alt={key.pymtMthdDesc} />
                                                ) : (
                                                    key.pymtMthdDesc
                                                )
                                            ) : (
                                                <>
                                                    <div className="pymtMthdLabel">
                                                        <input type="radio" name="pymtMthd" checked={pymtMthdCdState === `${key.pymtMthdCd}`} readOnly />
                                                        <label htmlFor={`pymtMthd-${key.pymtMthdCd}`}>
                                                            <p className={key.dpstEvntYn == "Y" ? "pymtMthdDesc evnt" : "pymtMthdDesc"}>{key.pymtMthdDesc}</p>
                                                        </label>
                                                    </div>
                                                    <img src={process.env.PUBLIC_URL + `/images/Shop/${key.pymtMthdCd}Img.png`} alt={key.pymtMthdDesc}/>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                ))}
                            </div>
                            {hasMorePymtMthd && (
                                <div className={`shopInlinePymtMoreWrap ${showAllPymtMthdState ? "isPlaceholder" : ""}`}>
                                    <button
                                        type="button"
                                        className="shopInlinePymtMoreBtn"
                                        onClick={() => setShowAllPymtMthdState(true)}
                                        disabled={showAllPymtMthdState}
                                        aria-hidden={showAllPymtMthdState}
                                        tabIndex={showAllPymtMthdState ? -1 : 0}
                                    >
                                        {langData?.COMM_MAIN_MORE_BTN_00 || "더보기"}
                                    </button>
                                </div>
                            )}

                            {pymtMthdEvntState && pymtMthdEvntState != null ?
                                <div className="shopInlinePymtEvent active"></div>
                                :
                                <div className="shopInlinePymtEvent"></div>
                            }


                            <form className="payment htmlFormData" method="post" name="payment">
                                <input type="hidden" name="SERVICE_ID" id="SERVICE_ID"/>
                                <input type="hidden" name="SERVICE_CODE" id="SERVICE_CODE"/>
                                <input type="hidden" name="SERVICE_TYPE" id="SERVICE_TYPE"/>
                                <input type="hidden" name="ITEM_NAME" id="ITEM_NAME"/>
                                <input type="hidden" name="ORDER_ID" id="ORDER_ID"/>
                                <input type="hidden" name="ORDER_DATE" id="ORDER_DATE"/>
                                <input type="hidden" name="AMOUNT" id="AMOUNT"/>
                                <input type="hidden" name="RETURN_URL" id="RETURN_URL"/>
                                <input type="hidden" name="ITEM_CODE" id="ITEM_CODE"/>
                                <input type="hidden" name="USER_ID" id="USER_ID"/>
                                <input type="hidden" name="USER_NAME" id="USER_NAME"/>
                                <input type="hidden" name="USER_EMAIL" id="USER_EMAIL"/>
                                <input type="hidden" name="RESERVED1" id="RESERVED1"/>
                                <input type="hidden" name="RESERVED2" id="RESERVED2"/>
                                <input type="hidden" name="RESERVED3" id="RESERVED3"/>
                                <input type="hidden" name="CANCEL_FLAG" id="CANCEL_FLAG"/>
                                <input type="hidden" name="WEBAPI_FLAG" id="WEBAPI_FLAG"/>
                                {shouldRenderPayType && (
                                <input type="hidden" name="PAY_TYPE" id="PAY_TYPE"/>
                                )}
                                <input type="hidden" name="HASH_KEY" id="HASH_KEY"/>
                                <input type="hidden" name="LOGO" id="LOGO"/>
                                <input type="hidden" name="INSTALLMENT_PERIOD" id="INSTALLMENT_PERIOD"/>
                            </form>
                        </div>
                        {oneLmtCntState === 1 ? 
                            <></> :
                            <div className="itemTxtRow">
                                <ul>
                                    <li className="prdtLbl">
                                        <p>{langData&&langData.GAME_SHOP_MNY_CNT_LBL_00}</p>
                                    </li>
                                    <li className="cntWrap">
                                        <button disabled={soutYnState === "Y"} onClick={()=>CntStateChngFunc("-")}>
                                            -
                                        </button>
                                        <div>
                                            <p>{countState}</p>
                                        </div>
                                        <button disabled={soutYnState === "Y"} onClick={()=>CntStateChngFunc("+")}>
                                            +
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        }
                        <div className="itemTxtRow02">
                            <ul>
                                <li className="prdtLbl">
                                    <p>{langData&&langData.GAME_SHOP_MNY_PRC_LBL_00}</p>
                                </li>
                                <li className="prdtLbl">
                                    <p><span>{pchsCrncySignState}</span>{(Number(prdtUntPrcState||0)).toLocaleString()}</p>
                                </li>
                            </ul>
                        </div>
                        <div className="itemTxtRow02 itemTxtRowTotal">
                            <ul>
                                <li className="prdtLbl">
                                    <p>{langData&&langData.GAME_SHOP_TOT_PRC_LBL_00}</p>
                                </li>
                                <li className="prdtLbl">
                                    <p><span>{pchsCrncySignState}{(Number(prdtUntPrcState||0)*countState).toLocaleString()}</span></p>
                                </li>
                            </ul>
                        </div>
                        <div className="shopInlineTermsWrap">
                            <div>
                                <input
                                    type="checkbox"
                                    name="agrePrivacy"
                                    className="agreChkBox"
                                    id="shopAgreePrivacy"
                                    checked={agreChkState.includes("agrePrivacy")}
                                    onChange={AgreTrmsFunc}
                                />
                                <label htmlFor="shopAgreePrivacy">{langData && langData.GAME_SHOP_ITEM_PAY_AGRE_INFO_LBL_00 || "결제할 상품의 정보, 수량, 결제 금액 및 유의사항을 확인하였습니다."}</label>
                            </div>
                        </div>
                        <div className="shopCtntStepAction btn100">
                            <button
                                className={`buttonBgB ${soutYnState === "Y" || !isPageReady ? "disabled" : ""}`}
                                disabled={soutYnState === "Y" || !isPageReady}
                                onClick={PymtBtnOnClickFunc}>
                                <p>{soutYnState === "Y" ? (langData&&langData.PRDT_SOLD_OUT_BTN_00) : (langData&&langData.GAME_SHOP_MNY_DPST_BTN_00)}</p>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
        )}
        </>
    )
}



export default ShopCtntMdlalUi;
